// extracted by css-extract-rspack-plugin
export default {"Box":"layout-selector-module__Box__N4WE9"};